import { createContext } from 'react'
import type { OrbitPageDescriptor } from './orbitTypes'

export type OrbitRegistryValue = {
  registerDescriptor: (descriptor: OrbitPageDescriptor) => () => void
  setDescriptor: (descriptor: OrbitPageDescriptor | null) => void
}

export const OrbitRegistryContext = createContext<OrbitRegistryValue | null>(null)
